import type { LocalizedText } from "../i18n/i18n";
import { filterSettingsItems, settingsCatalogGroups, type SettingsVisibilityContext } from "../../pages/settings/settingsCatalog";
import { normalizeMenuPath, type MenuRoute } from "./menu";

export type QuickSearchPage = {
  path: string;
  label: string;
  /** Übergeordneter Bereich (Menügruppe bzw. Einstellungsgruppe) zur Unterscheidung gleichnamiger Seiten. */
  context?: string;
};

const SETTINGS_GROUP_PREFIX = "/settings/group/";

/**
 * Seiten, die die Schnellsuche anbietet: alle Menüziele des Benutzers und die Einstellungsseiten der
 * Gruppen, die das Menü zeigt. Quelle sind ausschließlich das bereits rechtegefilterte Menü und der
 * Einstellungskatalog mit derselben Sichtbarkeitsprüfung wie die Gruppenseite — keine eigene Liste.
 */
export function buildQuickSearchPages(
  menu: MenuRoute[],
  settingsVisibility: SettingsVisibilityContext,
  text: (value: LocalizedText) => string
): QuickSearchPage[] {
  const pages: QuickSearchPage[] = [];
  const seen = new Set<string>();
  const add = (page: QuickSearchPage) => {
    const path = normalizeMenuPath(page.path);
    if (seen.has(path)) return;
    seen.add(path);
    pages.push({ ...page, path });
  };

  const walk = (routes: MenuRoute[], parent?: string) => {
    for (const route of routes) {
      add({ path: route.path, label: route.name, context: parent });
      if (route.path.startsWith(SETTINGS_GROUP_PREFIX)) {
        const group = settingsCatalogGroups.find((g) => `${SETTINGS_GROUP_PREFIX}${g.key}` === normalizeMenuPath(route.path));
        for (const item of filterSettingsItems(group?.items, settingsVisibility)) {
          add({ path: item.path, label: text(item.titleKey), context: route.name });
        }
      }
      if (route.children?.length) walk(route.children, route.name);
    }
  };
  walk(menu);
  return pages;
}

export { matchSearchPages as matchQuickSearchPages } from "../../../../../../shared/frontend/search/searchContract";
